import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import type { CompanyWrite } from "./useCreateOrganization";

type SaveSupplier = {
    company: CompanyWrite;
};

export const useSaveSupplier = () =>
    useMutation({
        mutationFn: async ({ company }: SaveSupplier) =>
            company.id === undefined ?
                await loggedInApiCall.post("/api/suppliers", company)
            :   await loggedInApiCall.put(`/api/suppliers/${company.id}`, company),
    });
